const translations: Record<string, string> = {
  "ak_scada2_running": "running",
  "ak_scada2_no_generation": "no generation",
  "ak_scada2_warning": "warning",
  "ak_scada2_alarm": "alarm",
  "ak_scada2_data_is_getting_stale": "data is getting stale",
  "ak_scada2_no_link": "no link",
  "ak_scada2_no_data": "no data",
  "ak_scada2_bus_i_section_d1": "Bus I · section D1",
  "ak_scada2_bus_ii_section_d2": "Bus II · section D2",
  "ak_scada2_kw": "kW",
  "ak_scada2_of": " of {{n}}",
  "ak_scada2_undetermined": " · undetermined: {{n}}",
  "ak_scada2_inverter": "Inverter",
  "ak_scada2_breaker": "breaker",
  "ak_scada2_hz": "Hz",
  "ak_scada2_ezlogger_from_the_station_network": "EzLogger {{ip}} — from the station network",
  "ak_scada2_per_the_addressing_table": "{{n}} per the addressing table · {{src}}",
  "ak_scada2_deviations": "Deviations ({{n}})",
  "ak_scada2_the_collector_returns_unit_ids_that_ar": "The collector returns Unit IDs that are not in the addressing table: {{ids}}.",
  "ak_scada2_breakers_qf_in_bus_order": "· breakers {{n}}.QF, in bus order",
  "ak_scada2_close": "Close",
  "ak_scada2_of_nominal": "% of nominal",
  "ak_scada2_frequency": "Frequency",
  "ak_scada2_last_data": "Last data",
  "ak_scada2_none": "none",
  "ak_scada2_status_raw": "Status (raw)",
  "ak_scada2_model": "Model",
  "ak_scada2_s_n_per_spec": "S/N per spec",
  "ak_scada2_logger": "Logger",
  "ak_scada2_plc_channel": "PLC channel",
  "ak_scada2_factory_interface": "Factory interface",
  "ak_scada2_power_per_day_kw": "Power per day, kW",
  "ak_scada2_no_daily_data_for_this_inverter": "No daily data for this inverter",
  "ak_scada2_loading": "Loading…",
  "ak_scada2_inverters": "Inverters",
  "ak_scada2_inverters_by_ktp_and_section": "Inverters by KTP and section",
  "ak_scada2_all_ktp": "All KTP",
  "ak_scada2_all": "All",
  "ak_scada2_search_45_u_2_qf6_s_n": "Search: 45.U, 2.QF6, S/N",
  "ak_scada2_inverter_search": "Inverter search",
  "ak_scada2_the_last_poll_failed_the_previous_snap": "The last poll failed - the previous snapshot is shown; its age is visible in the inverter details.",
  "ak_scada2_no_inverters_match_the_filter": "No inverters match the filter.",
  "ak_scada2_value_from_a_stale_snapshot_not_includ": "· \"~\" - value from a stale snapshot, not included in totals",
  "ak_scada2_off": "off",
  "ak_scada2_standby": "standby",
  "ak_scada2_charging": "charging",
  "ak_scada2_discharging": "discharging",
  "ak_scada2_running_2": "running",
  "ak_scada2_normal": "normal",
  "ak_scada2_racks": "racks {{r}} · {{ip}}",
  "ak_scada2_limit_kw_heatsink": "limit ±{{a}} kW · heatsink {{b}}°",
  "ak_scada2_battery": "Battery",
  "ak_scada2_cell_spread": "cell spread",
  "ak_scada2_mv": "mV",
  "ak_scada2_pack": "pack",
  "ak_scada2_v": "V",
  "ak_scada2_the_collector_groups_this_battery_with": "The collector groups this battery with {{p}}, while the spec says {{a}}, {{b}}.",
  "ak_scada2_4_blocks_2_batteries_pcs_a_b_sign_disc": "4 blocks × 2 batteries × PCS A/B · sign: + discharge, − charge · {{c}}, {{a}}",
  "ak_scada2_batteries": "batteries",
  "ak_scada2_alarms": " · alarms {{n}}",
  "ak_scada2_kwh": "kWh",
  "ak_scada2_kw_of": "kW of",
  "ak_scada2_the_collector_does_not_yet_collect_soc": "The collector does not yet collect SOC of individual rack groups 1–6 / 7–11 (SCU rack ports 503–513) - the overall battery SOC is shown. Individual rack errors and switching on a single PCS are handled in the factory interfaces of Jinko ESMS and Kehua, from the station network.",
  "ak_scada2_no_data_from_the_collector": "no data from the collector",
  "ak_scada2_active_pcs_alarm": "Active PCS alarm. ",
  "ak_scada2_the_pcs_of_the_pair_operate_in_opposit": "The PCS of the pair operate in opposite directions - the common direction rule is violated. ",
  "ak_scada2_bess_data_is_currently_unavailable": "BESS data is currently unavailable.",
  "ak_scada2_bess_by_equipment": "BESS by equipment",
  "ak_scada2_bess_power": "BESS power",
  "ak_scada2_system_soc": "System SOC",
  "ak_scada2_can_charge": "Can charge",
  "ak_scada2_can_discharge": "Can discharge",
  "ak_scada2_vs_med": "{{s}}{{d}}% vs med.",
  "ak_scada2_running_median": "{{w}}/{{n}} running · median {{m}}%",
  "ak_scada2_running_total_mw": "· {{a}}/{{e}} running · total {{p}} MW",
  "ak_scada2_max_spread": "max. spread {{n}}%",
  "ak_scada2_weakest_typical_strongest": "weakest {{a}}%  ·  typical {{b}}%  ·  strongest {{c}}%",
  "ak_scada2_offline": "offline",
  "ak_scada2_estimate": "estimate",
  "ak_scada2_nom": "% nom.",
  "ak_scada2_inverter_technical_status": "Inverter technical status",
  "ak_scada2_each_inverter_power_of_nominal_deviati": "Each inverter: power, % of nominal, deviation from the group median",
  "ak_scada2_station_inverter_fleet_status": "Station inverter fleet status",
  "ak_scada2_no_inverter_data_for_this_station": "No inverter data for this station.",
  "ak_scada2_the_controller_sends_totals_only_no_pe": "the controller sends totals only - no per-inverter breakdown",
  "ak_scada2_station_power_per_day": "Station power per day",
  "ak_scada2_inverter_uniformity_per_day": "Inverter uniformity per day",
  "ak_scada2_total_station_power_aggregated_meterin": "Total station power (aggregated metering - per-inverter distribution is unavailable)",
  "ak_scada2_green_line_the_typical_average_inverte": "Green line - the typical (average) inverter; the band - the gap between the strongest and the weakest. A narrow band = all work equally, a wider one = some inverter lags behind.",
  "ak_scada2_no_data_for_today": "No data for today.",
  "ak_scada2_time_of_day": "Time of day",
  "ak_scada2_of_nominal_2": "% of nominal",
  "ak_scada2_power": "Power",
  "ak_scada2_spread": "Spread",
  "ak_scada2_median": "Median",
  "ak_scada2_the_station_controller_sends_only_a_to": "The station controller sends only a total value, so the status of each inverter is not available separately. The number running is taken from the controller counter.",
  "ak_scada2_inverters_running": "Inverters ({{w}}/{{n}} running)",
  "ak_scada2_median_2": "median {{m}}%",
  "ak_scada2_lagging_behind_the_group": "Lagging behind the group:",
  "ak_scada2_vs_median": "{{s}}{{d}}% vs median",
  "ak_scada2_inv_details": "INV-{{n}} — details",
  "ak_scada2_updated": "updated {{t}}",
  "ak_scada2_inverter_data_is_not_available_for_thi": "Inverter data is not available for this station.",
  "ak_scada2_aggregated_metering_per_inverter_data": "Aggregated metering - per-inverter data is not transmitted",
  "ak_scada2_heat_map_by_deviation_from_the_group_m": "Heat map by deviation from the group median · click an inverter for details",
  "ak_scada2_all_inverters_are_within_the_norm_rela": "All inverters are within the norm relative to the group.",
  "ak_scada2_normal_3": "normal (≥ −3%)",
  "ak_scada2_below_3_10": "below (−3…−10%)",
  "ak_scada2_lagging_10": "lagging (< −10%)",
  "ak_scada2_phase": "Phase",
  "ak_scada2_voltage_v": "Voltage, V",
  "ak_scada2_current_a": "Current, A",
  "ak_scada2_power_kw": "Power, kW",
  "ak_scada2_phase_voltage_per_day_v": "Phase voltage per day, V",
  "ak_scada2_phase_current_per_day_a": "Phase current per day, A",
  "ak_scada2_mw": "MW",
  "ak_scada2_kv": "kV",
  "ak_scada2_a": "A",
  "ak_scada2_strings": "strings {{a}}/{{b}}",
  "ak_scada2_strings_ok": "{{id}} · strings ({{a}}/{{b}} OK)",
  "ak_scada2_group_load": "Group load",
  "ak_scada2_running_3": "Running",
  "ak_scada2_voltage_u": "Voltage U",
  "ak_scada2_current_i": "Current I",
  "ak_scada2_temperature_t": "Temperature T",
  "ak_scada2_bess": "BESS",
  "ak_scada2_standby_2": "standby",
  "ak_scada2_mode": "Mode",
  "ak_scada2_point_of_connection": "Point of connection",
  "ak_scada2_limit": "Limit",
  "ak_scada2_inverter_2": "Inverter {{id}}",
  "ak_scada2_storage": "Storage • {{m}}",
  "ak_scada2_inverters_running_2": "{{w}}/{{t}} inverters running",
  "ak_scada2_voltage": "Voltage",
  "ak_scada2_current": "Current",
  "ak_scada2_temperature": "Temperature",
  "ak_scada2_efficiency": "Efficiency",
  "ak_scada2_bess_2": "BESS",
  "ak_scada2_charge": "Charge",
  "ak_scada2_charging_power": "Charging power",
  "ak_scada2_discharging_power": "Discharging power",
  "ak_scada2_health": "Health",
  "ak_scada2_groups": "Groups",
  "ak_scada2_group": "Group {{n}}",
  "ak_scada2_discharge": "Discharge",
  "ak_scada2_alarm_2": "Alarm",
  "ak_scada2_standby_3": "Standby",
  "ak_scada2_inverters_2": "inverters",
  "ak_scada2_more": "{{n}} more",
};

export default translations;
